export var baseCommon = {
    requestId: 'MSWMOCK-a2355033-bc0f-4dc8-a16f-a856f26f9ccd',
    timestamp: '2024-04-25 12:48:59',
    type: 'LOAN',
    hashType: 'FINANCING-OBJECT',
};
export var agreementsCommon = {
    marketing: [
        {
            provider: 'test-provider',
            accepted: true,
            timestamp: '2024-05-16T07:38:18.593Z',
        },
    ],
};
export var preLimitsCommon = [
    {
        id: 12345,
        min: 10000,
        max: 5000,
        currency: 'PLN',
        provider: 'test-provider',
        availableLimitRevenueRate: [
            {
                period: 12,
                pricing: 30,
                loanRepaymentPrice: 3.6,
                amountMin: 10000,
                amountMax: 20000,
            },
            {
                period: 6,
                pricing: 30,
                loanRepaymentPrice: 3.6,
                amountMin: 10000,
                amountMax: 20000,
            },
        ],
    },
];
export var representativeCommon = [
    {
        id: 123,
        name: 'Msw',
        surname: 'Mock',
        pesel: '00000000000',
        document: {
            type: 'idCard',
            number: 'AKX105779',
            country: 'PL',
        },
    },
];
export var bankAccountCommon = [
    {
        id: 1234,
        iban: 'PL68102045645609879769242394',
    },
];
export var merchantCommon = {
    mvm: true,
    name: 'Msw company',
    vat: '1100031117',
    companyType: 'zoo',
    mcc: '1234',
    pos: 'v',
    mid: 'v',
    phone: '123456789',
    email: 'test@przelewy24.pl',
    activity: true,
    shops: [{ id: 1, name: 'Testowy shop' }],
    bankAccount: bankAccountCommon,
    representative: representativeCommon,
    address: {
        country: 'pl',
        city: 'Warszawa',
        postCode: '01-002',
        street: 'Staffa 105B',
    },
    beneficiary: [
        {
            id: 1,
            name: 'Jan Kowalski',
            pesel: '92011102599',
            document: { type: 'idCard', number: 'AKX105779', country: 'PL' },
        },
    ],
    companyRegisterDate: '2025-08-07',
};
export var configCommon = [
    {
        active: true,
        provider: 'pragma',
        companyType: 'zoo',
        default: true,
        discountEnabled: true,
        logo: {
            pl: {
                desktop: 'https://www.przelewy24.pl/themes/przelewy24/assets/img/base/przelewy24_logo_2022.svg',
                mobile: 'https://www.przelewy24.pl/themes/przelewy24/assets/img/base/przelewy24_logo_2022.svg',
            },
            en: {
                desktop: 'https://www.przelewy24.pl/themes/przelewy24/assets/img/base/przelewy24_logo_2022.svg',
                mobile: 'https://www.przelewy24.pl/themes/przelewy24/assets/img/base/przelewy24_logo_2022.svg',
            },
        },
        parameters: [
            {
                name: 'name_surname',
                editable: true,
            },
            {
                name: 'phone',
                editable: false,
            },
            {
                name: 'mail',
                editable: false,
            },
            {
                name: 'taxId',
                editable: false,
            },
            {
                name: 'bankAccount',
                editable: true,
            },
            {
                name: 'companyName',
                editable: false,
            },
        ],
    },
];
